import { useMemo } from 'react';

type PortalMode = 'admin';

function getDefaultPortalPath(): '/admin' {
    return '/admin';
}

function getPortalModeFromPath(): PortalMode {
    return 'admin';
}

export function usePortalMode() {
    return useMemo(
        () => ({
            mode: getPortalModeFromPath(),
            defaultPath: getDefaultPortalPath(),
            canAccessAdmin: true,
            isLoading: false,
        }),
        [],
    );
}
